import * as React from 'react';
import { DiscountIcon } from '../../../../web/components/svgs/icons/DiscountIcon';
import { UsersIcon } from '../../../../web/components/svgs/icons/UsersIcon';
import { SettingsCard, SettingsCardGrid } from '../../../components/SettingsCard';
import { IntegrationOptions } from '../';

export const IntegrationCards: React.FC = () => (
	<SettingsCardGrid>
		<SettingsCard
			description='HubSpot deal fields reps fill in when they add a deal'
			hue='orange'
			renderIcon={className => <DiscountIcon className={className} fillColor='currentColor' />}
			title='Deal Properties'
			to={`/integration/${IntegrationOptions.DealProperties}`}
		/>
		<SettingsCard
			description='HubSpot fields used as lead tags and lead pools'
			hue='teal'
			renderIcon={className => <UsersIcon className={className} />}
			title='Lead Properties'
			to={`/integration/${IntegrationOptions.LeadProperties}`}
		/>
	</SettingsCardGrid>
);
